import LogoMark from "@icons/LogoMark.svg?react"
import LogoSubtext from "@icons/LogoSubtext.svg?react"
import SquareLogoDuotone from "@icons/SquareLogoDuotone.svg?react"
import clsx from "clsx/lite"

export default ({
    className = "max-w-[302px]",
    primaryStyle = "fill-white-snow stroke-white-snow",
    subtext = true,
    subtextStyle = "fill-sticks-and-stones stroke-sticks-and-stones",
    logo = false,
    position = "top",
}) => (
    <div
        className={clsx(
            "flex",
            logo && position == "top" ? "flex-col" : "",
            position == "left" ? "items-center" : "",
            className,
        )}
    >
        {logo && position == "top" && (
            <SquareLogoDuotone className="size-20 mx-auto -mb-2 -translate-x-2" />
        )}
        {logo && position == "left" && (
            <SquareLogoDuotone className="size-20 mr-4" />
        )}
        <div className={clsx(subtext ? "grid grid-cols-24 grid-rows-9" : "")}>
            <LogoMark
                className={clsx(
                    "w-full",
                    subtext ?
                        "col-start-1 col-span-24 row-start-3 row-span-3"
                    :   "",
                    primaryStyle,
                )}
            />
            {subtext && (
                <LogoSubtext
                    className={clsx(
                        "row-start-7 row-span-1 col-start-5 col-span-16 w-full",
                        subtextStyle,
                    )}
                />
            )}
        </div>
    </div>
)
